import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { RiCloseLine } from '@remixicon/react';
import OperatorProfile from '../pages/OperatorProfile';

const OperatorDetailsDrawer = ({ isOpen, onClose, operatorId }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !operatorId) return null;

  const drawerContent = (
    <div className="fixed inset-0 z-[9999]">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="absolute right-0 top-0 bottom-0 w-full max-w-6xl bg-gray-50 shadow-2xl flex flex-col">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex-shrink-0">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900">Operator Profile</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <RiCloseLine className="w-6 h-6 text-gray-500" />
            </button>
          </div>
        </div>

        {/* Content - Reuse OperatorProfile component */}
        <div className="flex-1 overflow-hidden">
          <OperatorProfile operatorId={operatorId} isDrawer />
        </div>
      </div>
    </div>
  );

  return createPortal(drawerContent, document.body);
};

export default OperatorDetailsDrawer;
